export const jidsConsumableSupplyNotification = [
  'California',
  'Colorado',
  'Connecticut',
  'Florida',
  'Georgia',
  'Indiana',
  'Michigan',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'North Carolina',
  'Washington',
];
